import { useCallback, useContext, useEffect, useState } from 'react';
import {
  ActionDependant,
  evaluateTemplateValue,
  GlobalDataContext,
  TemplateContext,
} from '@ea-lab/reactive-json';
import { History, X } from 'lucide-react';
import { useDocRevisions } from '../shell/useDocRevisions';
import RevisionTimeline from '../shell/RevisionTimeline';

export const DocHistory = ({ props }) => {
  const globalDataContext = useContext(GlobalDataContext);
  const templateContext = useContext(TemplateContext);
  const [isOpen, setIsOpen] = useState(false);

  const pageId = evaluateTemplateValue({
    valueToEvaluate: props.pageId,
    globalDataContext,
    templateContext,
  });

  const { revisions, loading, error, reload } = useDocRevisions(isOpen ? pageId : null);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  useEffect(() => {
    if (isOpen && pageId) reload();
  }, [isOpen, pageId, reload]);

  const handleClose = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => { if (e.key === 'Escape') handleClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen, handleClose]);

  return (
    <ActionDependant {...props}>
      <button
        onClick={handleOpen}
        className="inline-flex items-center gap-1.5 px-3.5 py-2 text-stone-600 hover:bg-stone-100 border border-stone-200 rounded-xl text-sm font-medium transition-all shadow-sm"
        aria-label="Historique des révisions"
      >
        <History size={14} />
        <span className="hidden sm:inline">Historique</span>
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={handleClose} />
          <div className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl z-50 flex flex-col border-l border-stone-200" role="dialog" aria-modal="true">
            <div className="flex items-center justify-between px-6 py-4 border-b border-stone-200">
              <h2 className="text-lg font-semibold text-stone-900">Historique des révisions</h2>
              <button
                onClick={handleClose}
                className="p-1 rounded-lg hover:bg-stone-100 text-stone-400 transition-colors"
                aria-label="Fermer"
              >
                <X size={18} />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto px-6 py-4">
              <RevisionTimeline revisions={revisions} loading={loading} error={error} variant="full" />
            </div>
          </div>
        </>
      )}
    </ActionDependant>
  );
};
